import { render, staticRenderFns } from "./BizEndorseForm.vue?vue&type=template&id=0ed49e82&"
import script from "./BizEndorseForm.vue?vue&type=script&lang=js&"
export * from "./BizEndorseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports